import React from 'react';
const carriers = ['Aetna', 'Cigna', 'UnitedHealthcare', 'Humana', 'Blue Cross', 'Mutual of Omaha'];
export function CarriersBar() {
  return <section className="py-10 bg-white border-y border-slate-100 overflow-hidden" data-id="element-29">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-30">
        <p className="text-center text-sm font-semibold text-slate-400 uppercase tracking-wider mb-6" data-id="element-31">
          Trusted by the nation's leading carriers
        </p>

        {/* Simple flex layout for desktop, scrolling for mobile */}
        <div className="flex overflow-x-auto pb-4 sm:pb-0 hide-scrollbar justify-start sm:justify-center items-center gap-8 md:gap-16 opacity-60 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-32">
          {carriers.map((carrier, index) => <div key={index} className="flex-shrink-0" data-id="element-33">
              <span className="font-serif font-bold text-2xl text-slate-800 whitespace-nowrap" data-id="element-34">
                {carrier}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}